import { List, Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import PsContext from "../../context";
import { momentDate, queryParam, upperCase, useQuery } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import DayWiseMarkedAndPending from "./dayWiseMarkedAndPending";

const DayOrderByDates = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [selectedDate, setSelectedDate] = useState([]);

  const params = useParams();
  let searchParams = queryParam(useQuery());

  useEffect(() => {
    loadDayOrders();
  }, []);
  console.log(props);
  const loadDayOrders = () => {
    context.setLoader(true);
    const form = new FormData();
    form.append("attendance_date", props.attendance_date);
    form.append("category", props.category);
    form.append("acyear", props.acyear);
    form.append("teacher", context.user.id);
    form.append("floor_id", props.floor_id);
    axios
      .post(ServiceUrl.MOB.LIST_HOSTEL_ATTENDANCE_DATES, form)
      .then((res) => {
        if (res["data"].status == "1") {
          let m = res["data"].data;
          setDataList(m);
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }

        context.setLoader(false);
      });
  };

  const getTitle = () => {
    return params?.type
      ? `${upperCase(params.type)} Attendance Marked Report`
      : "Attendance Marked Report";
  };

  const bakcLinkClick = () => {
    let path = params?.type ? "/staff/app/my-att-report" : "/staff/app";
    navigate(path);
  };

  return (
    <>
      <Header
        onBack={(e) => bakcLinkClick()}
        title={getTitle()}
        backAction={true}
        rightActions={[]}
      />

      <section className="top-space pt-0 pb-0">
        <List>
          {dataList.map((item) => (
            <List.Item
              className="ps-3"
              onClick={(e) => {
                setSelectedDate(item);
                setShowModal(true);
              }}
            >
              {momentDate(item.attendance_date, "DD/MMM/YYYY")}
            </List.Item>
          ))}
        </List>
      </section>

      <Modal
        show={showModal}
        onHide={(e) => {
          setShowModal(false);
          setSelectedDate(false);
        }}
        fullscreen
      >
        <Modal.Header className="fw-bold" closeButton>
          Marked List
        </Modal.Header>
        <Modal.Body>
          <DayWiseMarkedAndPending dayOrder={selectedDate} />
        </Modal.Body>
      </Modal>
    </>
  );
};
export default DayOrderByDates;
